export {
  Icon,
  type IconProps,
  type IconName,
} from '@tui-cruises/mein-schiff-web-react-component-library/src/components/core/Icon';
